<template>
  <div class="container">
    <div v-if="questions.length>0">
      <div class="question_list" v-for="(item,index) in questions[0]" :key="index">
        <Question :questions="item" :sort="item.sort" @selectRadio="selectRadio($event,item.sort)"></Question>
      </div>
      <div class="question_need">本次为匿名调查，需要提供部分个人信息，用于后续的问卷分析。</div>
      <div class="question_list" v-for="(item,index) in questions[1]" :key="item.sort">
        <Question :questions="item" :sort="item.sort" @selectRadio="selectRadio($event,item.sort)"></Question>
      </div>
      <div class="question_btn">
        <el-button type="primary" style="width: 100%;font-size: .32rem;" @click="submitBtn">提交</el-button>
      </div>
    </div>
    <div class="noCard" v-if="!questions.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无调查问卷</div>
    </div>
  </div>
</template>

<script>
  import Question from '../common/Question'
  import {GetQuestion,SaveQuestion} from '../../api/index'
    export default {
        name: "questionnaire",
      components:{
        Question
      },
      data(){
          return{
            questions:[],
            results:[]
          }
      },
      created() {
        //修改标题
        document.title = this.$route.query.name
        this.getQuestion()
      },
      methods:{
        selectRadio(item,id){
          if(this.results.length>0){  //判断结果是否为空
            let find = this.results.findIndex((v)=>{ return  v.pid==id})
            if(find > -1){  //判断结果里是否有相同的id
              this.results = this.results.map(m=>{return m.pid==id?{pid:id,result:item}:m})   //覆盖掉id相同的那条数据
            }else {
              this.results.push({pid:id,result:item})
            }
          }else {
            this.results.push({pid:id,result:item})
          }
        },
        getQuestion(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          GetQuestion({struid:this.$route.query.id}).then(res=>{
            loading.close();
            if(res.IsSuccess){
              this.questions = res.Data
            }else {
              this.$message({
                message: res.Msg,
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
            }
          })
        },
        submitBtn(){
          if(this.results.length===(this.questions[0].length+this.questions[1].length)){  //通过结果的长度是否等于问题的总长度 判断是否填写完整
            SaveQuestion(this.$route.query.id,{strPostInfo:JSON.stringify(this.results),openid:this.$storage.get('openid')}).then(res=>{
              if(res.IsSuccess){
                this.$message({
                  type: 'success',
                  message: '提交成功！',
                  duration:3000,
                  offset:200
                });
                setTimeout(() => {
                  this.$router.push({path:'/satisfactionSurvey'})
                }, 500)
              }else {
                this.$message({
                  message: res.Msg,
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
              }
            })
          }else {
            this.$message({
              message: '请将问卷填写完整！',
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
          }
        },
      }
    }
</script>

<style scoped>
  .container{
    width: 100%;
    height: 100vh;
    font-size: .3rem;
  }
  .question_list{
    width: 90%;
    margin: 0 auto;
  }
  .question_need{
    width: 90%;
    margin: .3rem auto;
    font-size: .32rem;
    font-weight: 700;
  }
  .question_btn{
    width: 90%;
    margin: .5rem auto;
    padding-bottom: .8rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/questionnaire.vue